import cn from '@/lib/cs';
import React from 'react';

const PauseIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.3 2.3C7 3 6 4.8 5.8 5.4L5 9.2l-.2 6.5-.8 4.6c.2.7 1.4 1.5 1.6 2.2l1.3.5 1.2-.7a90 90 0 001-5.6l1-7c0-1.3 0-2.7.2-4-.4-1.9.2-5.3-2-4.5-.3.7-.7.4-1 1.1zm11.4 1.2v2.2l.3 5.9c-.3 2.1-.6 2.2-.9 4.3v4.7c-.2.7-1.5 1.4-1.8 2.1l-1.5.3-1-1c0-2.2-.2-4.2-.1-5.6l.2-5c.1-1.3 1.3-4.7.4-6C15 3.6 15 0 17 1.2c.2.8 1.5 1.6 1.7 2.3z"
		/>
	</svg>
);

export default PauseIcon;
